import groupsTemplate from './groups.html';

export default angular
  .module('main.reports.view.tabs.groups', [])

  .directive('reportViewGroupsTab', () => {
    return {
      restrict: 'E',
      template: groupsTemplate,
      scope: {},
      controller: ($scope, ViewReportDataProvider) => {

        const dataProvider = ViewReportDataProvider.instance;
        $scope.dataProvider = dataProvider;

        $scope.loading = false;
        $scope.report = angular.copy(dataProvider.reportResource.value);
        $scope.orgInfo = dataProvider.orgInfo;

        angular.extend($scope, {
          back: () => dataProvider.goBack(),
          canEditOrg: () => dataProvider.canEditOrg(),
          onManageGroupsClick: () => dataProvider.onManageGroupsClick(),
        });

      }
    };
  })
  .name;
